/**
 * An input the service rejected before making any request.
 *
 * `severity` classifies how serious the problem is; the React layer maps it onto
 * a toast type. The service says what went wrong and how bad it is, the UI
 * decides how to show it.
 *
 * @param {string} message text to show the user
 * @param {"warn"|"error"} [severity]
 * @returns {Error}
 */
export const validationError = (message, severity = "error") => {
  const error = new Error(message);
  error.isValidation = true;
  error.severity = severity;
  return error;
};

/**
 * Toast method name for a caught error - validation errors carry their own
 * severity, anything else is an error.
 *
 * @param {unknown} error
 * @returns {"warn"|"error"}
 */
export const severityOf = (error) => error?.severity || "error";
